import { Card, Text } from "@overmap-ai/blocks"
import { type AssetAttachment, type Stored } from "@overmap-ai/common"
import { selectUserById } from "@overmap-ai/core"
import { memo } from "react"

import { AssetTimelineItemType } from "../../enums/assets"
import { assetTimelineItemTypeData } from "../../mappings/assets"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { TimelineIconRail } from "../TimelineIconRail/TimelineIconRail"
import type { AssetTimelineSize } from "./typings"

interface AssetAttachmentTimelineItemProps {
	assetAttachment: Stored<AssetAttachment>
	size: AssetTimelineSize
}

export const AssetAttachmentTimelineItem = memo<AssetAttachmentTimelineItemProps>((props) => {
	const { assetAttachment, size } = props

	const createdBy = useAppSelector(selectUserById(assetAttachment.created_by ?? -1))

	const { icon } = assetTimelineItemTypeData[AssetTimelineItemType.ATTACHMENT]

	return (
		<div className="flex h-max w-full gap-4">
			<TimelineIconRail icon={icon} size={size} />
			<Card className="flex min-w-0 grow flex-col gap-1" size={size}>
				<Text size={size} accentColor="base">
					<Text highContrast>{getUserDisplayLabel(createdBy)}</Text>
					&nbsp;added an attachment
					<Text accentColor="base">&nbsp;&#8226;&nbsp;{formatCompactDate(assetAttachment.submitted_at)}</Text>
				</Text>

				<Text accentColor="base" className="min-w-0 truncate" size={size} highContrast>
					{assetAttachment.file_name}
				</Text>
			</Card>
		</div>
	)
})
AssetAttachmentTimelineItem.displayName = "AssetAttachmentTimelineItem"
